import * as types from '@/store/mutation-types'
import apolloClient from '@/api/apollo'

import ACTIVATE_EMAIL from '@/graphql/mutations/ConfirmEmail/ActivateEmail.graphql'

const module = {
  namespaced: true,
  state: {
    clientName: null
  },
  mutations: {
    [types.SET_CLIENT_NAME] (state, { clientName }) {
      state.clientName = clientName
    }
  },
  actions: {
    async activateEmail ({ commit }, { token }) {
      const result = await apolloClient.mutate({
        mutation: ACTIVATE_EMAIL,
        variables: {
          token
        }
      })
      const clientName = result.data.activateEmail.name
      commit(types.SET_CLIENT_NAME, { clientName })
    }
  }
}

export default module



// WEBPACK FOOTER //
// ./src/store/modules/confirm-email/index.js